import { render, staticRenderFns } from "./AllQuestion.vue?vue&type=template&id=2c6b4cab&"
import script from "./AllQuestion.vue?vue&type=script&lang=js&"
export * from "./AllQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AllQuestion.vue?vue&type=style&index=0&id=2c6b4cab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports